<lib-small-aside-layout [formGroup]="submitForm">
  <div aside-container>
    <ng-container *ngIf="shouldDisplayAdvanceForm()">
      <ng-container *ngIf="!originalAppointment?.id">
        <h3>
          {{
            'lib_calendar.appointment-form.text.customer-selection' | translate
          }}
        </h3>

        <lib-spacer [height]="10"></lib-spacer>

        <lib-base-card>
          <div class="card-content">
            <lib-customer-selection-form
              [mode]="mode"
              [businessObject]="businessObject"
              [customers]="customers"
              [formControlName]="FORM_NAME.CUSTOMER_ID"
              (customersChange)="customersChange.emit($event)"
            ></lib-customer-selection-form>
          </div>
        </lib-base-card>

        <lib-spacer></lib-spacer>
      </ng-container>

      <h3>
        {{ 'lib_calendar.appointment-form.text.note' | translate }}
      </h3>

      <lib-spacer [height]="10"></lib-spacer>

      <lib-base-card>
        <div class="card-content">
          <mat-form-field>
            <mat-label>{{
              'lib_calendar.appointment-form.text.note' | translate
            }}</mat-label>
            <textarea
              [formControlName]="FORM_NAME.NOTE"
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="5"
            ></textarea>
          </mat-form-field>
        </div>
      </lib-base-card>

      <lib-spacer></lib-spacer>
    </ng-container>

    <h3>
      {{ 'lib_calendar.appointment-form.text.staff-selection' | translate }}
    </h3>

    <lib-spacer [height]="10"></lib-spacer>

    <lib-base-card>
      <div class="card-content">
        <lib-staff-selection-form
          [staffs]="staffs"
          [formControlName]="FORM_NAME.STAFF_ID"
        ></lib-staff-selection-form>

        <ng-container *ngIf="shouldDisplayAdvanceForm()">
          <lib-spacer [height]="5"></lib-spacer>

          <mat-checkbox
            [formControlName]="FORM_NAME.STAFF_SELECTED_BY_CUSTOMER"
            [disabled]="controlStaffSelectedByCustomer.disabled"
            color="primary"
          >
            {{
              'lib_calendar.appointment-form.text.staff_selected_by_customer'
                | translate
            }}
          </mat-checkbox>
        </ng-container>

        <ng-container *ngIf="staffCannotServeAnyProduct">
          <lib-spacer [height]="10"></lib-spacer>

          <lib-info-box>
            <span>{{
              'lib_calendar.appointment-form.text.staff-cannot-serve-any-hint'
                | translate
            }}</span>
          </lib-info-box>
        </ng-container>

        <ng-container *ngIf="staffCannotServeAllProduct">
          <lib-spacer [height]="10"></lib-spacer>

          <lib-info-box>
            <span>{{
              'lib_calendar.appointment-form.text.staff-cannot-serve-all-hint'
                | translate
            }}</span>
          </lib-info-box>
        </ng-container>
      </div>
    </lib-base-card>

    <lib-spacer></lib-spacer>

    <h3>
      {{ 'lib_calendar.appointment-form.text.service-selection' | translate }}
    </h3>

    <lib-spacer [height]="10"></lib-spacer>

    <lib-base-card>
      <div class="card-content">
        <ng-container *ngIf="isRwgAppointment">
          <lib-info-box>
            <span>
              {{
                'lib_calendar.appointment-form.text.rwg_appointment_hint'
                  | translate
              }}
            </span>
          </lib-info-box>

          <lib-spacer [height]="10"></lib-spacer>
        </ng-container>

        <lib-service-selection-form
          [businessObject]="businessObject"
          [selectedTime]="controlStartTime.value"
          [formControlName]="FORM_NAME.PRODUCT_IDS"
          [estimatedDuration]="controlDuration.value"
          [enableCustomDuration]="shouldDisplayAdvanceForm()"
          (durationChanged)="updateEstimatedDuration($event)"
        ></lib-service-selection-form>
      </div>
    </lib-base-card>
  </div>

  <lib-calendar-available-slot-selection-form
    content-container
    [appointmentId]="originalAppointment?.id"
    [businessObject]="businessObject"
    [selectedProductIds]="
      isRwgAppointment
        ? getOriginalSelectedProductIds()
        : controlProductIds.value
    "
    [customDuration]="controlDuration.value"
    [selectedStaffId]="controlStaffId.value"
    [formControlName]="FORM_NAME.START_TIME"
  ></lib-calendar-available-slot-selection-form>
</lib-small-aside-layout>
